import Instagram from '../assets/contacts_imgs/instagram.png';
import Email from '../assets/contacts_imgs/email.png';
import Discord from '../assets/contacts_imgs/discord.png';
import LinkedIn from '../assets/contacts_imgs/linkedin.png';

const ContactInfo = [
  {
    name: 'Instagram',
    image: Instagram,
    link: 'https://www.instagram.com/swe.atucsd/',
  },
  {
    name: 'Email',
    image: Email,
    link: 'mailto:sweatucsd@swe.org',
  },
  {
    name: 'Discord',
    image: Discord,
    link: 'https://discord.gg/3HrqkHUzCR',
  },
  {
    name: 'LinkedIn',
    image: LinkedIn,
    link: 'https://www.linkedin.com/company/society-of-women-engineers-at-uc-san-diego/',
  },
];

export default ContactInfo;
